import { Check } from 'lucide-react';
import { PaymentType } from 'pages/Job/context';

import useBasePaymentSelectCard from './useBasePaymentSelectCard';

import FinancePaymentCard from '../FinancePaymentCard';
import OpenBankingPaymentCard from '../OpenBankingPaymentCard';

export interface BasePaymentSelectCardProps {
  type: PaymentType;
}

const BasePaymentSelectCard: React.FunctionComponent<BasePaymentSelectCardProps> =
  function ({ type }) {
    const { buttonClassName, buttonId, onClick, indicatorClassName, title } =
      useBasePaymentSelectCard(type);
    return (
      <button
        type="button"
        id={buttonId}
        onClick={onClick}
        className={buttonClassName}
      >
        <div className="w-full flex flex-row gap-x-4 mb-2 md:mb-3">
          <div className={indicatorClassName}>
            <Check
              size={16}
              className="text-neutral-000 stroke-neutral-000 m-auto"
            />
          </div>
          <p className="text-16-24-em text-neutral-800">{title}</p>
        </div>
        {type === 'FINANCE' && <FinancePaymentCard />}
        {type === 'OPEN_BANKING' && <OpenBankingPaymentCard />}
      </button>
    );
  };

export default BasePaymentSelectCard;
